import { DocumentTableRow } from 'features/knowledgeDocumentViewer/components/advancedSearch/DocumentTableColumns'
import { RecentDocumentCard } from 'features/knowledgeDocumentViewer/components/advancedSearch/RecentDocumentCard'
import React from 'react'
import styled from 'styled-components'

const Container = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
  padding: 0 1rem 0.75rem 1rem;
  border-bottom: 1px solid ${(props) => props.theme.forecast.border};
  flex-shrink: 0;
`

const ScrollContainer = styled.div`
  display: flex;
  gap: 0.5rem;
  overflow-x: auto;
  flex: 1;
  min-width: 0;
  padding-bottom: 0.25rem;
`

interface RecentDocumentsProps {
  documents: DocumentTableRow[]
  selectedDocumentId?: string | null
  onSelectDocument: (
    document: DocumentTableRow,
    event?: React.MouseEvent
  ) => void
  onContextMenu?: (document: DocumentTableRow, event: React.MouseEvent) => void
}

export const RecentDocuments: React.FC<RecentDocumentsProps> = ({
  documents,
  selectedDocumentId,
  onSelectDocument,
  onContextMenu,
}) => {
  if (documents.length === 0) {
    return null
  }

  return (
    <Container>
      <ScrollContainer>
        {documents.map((doc) => (
          <RecentDocumentCard
            key={doc.id}
            document={doc}
            isSelected={doc.id === selectedDocumentId}
            onClick={onSelectDocument}
            onContextMenu={onContextMenu}
          />
        ))}
      </ScrollContainer>
    </Container>
  )
}
